import { MouseEvent } from 'react'

export type ForexTileTicker =
  | 'AUDUSD'
  | 'BTCUSD'
  | 'EURGBP'
  | 'EURUSD'
  | 'GBPJPY'
  | 'GBPUSD'
  | 'NZDUSD'
  | 'USDCAD'
  | 'USDCHF'
  | 'USDJPY'
  | 'SI'
  | 'GC'
  | 'CL'

export enum PageType {
  Quotes = 'quotes',
  Performance = 'performance',
  Charts = 'charts',
}

export interface ForexTile {
  label: string
  ticker: string
  last: number
  change: number
  prevClose: number
  high: number
  low: number
  sparkline: number[]
  sparklineDateChanges: Record<string, string>
}

export type ForexTileMap = Record<ForexTileTicker, ForexTile>

export interface TimeFrame {
  key: string
  value: string
  title?: string
}

export interface TimeFrames<Key = string> {
  active: string
  link: (timeFrame: Key) => string
  onClick: (timeFrame: Key, e: MouseEvent) => void
  timeframes: TimeFrame[]
}
